<template>
    <div class="edit-pin-images">
        <figure class="figure">
            <input type="hidden" name="primary_image_id" :value="primary.id">
            <img class="img-thumbnail" :src="'https://pinandpop.s3.amazonaws.com/' + primary.url" :alt="title">
        </figure>

        <h6 class="small text-muted">Select thumbnail to set it as the primary image.</h6>
        <div class="row">
            <div class="col-6 pb-4 text-center" v-for="image in pinImages">
                <input type="hidden" name="image_ids[]" :value="image.id" :disabled="image.deleted_at">
                <img :src="'https://pinandpop.s3.amazonaws.com/' + image.url"
                     :class="{ 'primary-image': image.is_primary, 'opacity-50': image.deleted_at }"
                     class="img-thumbnail primary-option"
                     :title="image.id"
                     @click="updatePrimaryImage(image)">
                <template v-if="adv">
                    <div>
                        <select name="image_users[]" class="form-select form-select-sm" :disabled="image.deleted_at" v-model="image.user_id">
                            <option v-for="(user, key) in users" :value="key" :selected="image.user_id === key">{{ user }}</option>
                        </select>
                        <button @click.prevent="image.deleted_at=!image.deleted_at" type="button" class="btn btn-link text-danger btn-sm mt-2">{{ image.deleted_at ? 'restore' : 'delete' }}</button>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EditPinImages",
        props: ['images', 'title', 'adv'],
        data: function () {
            return {
                primary: {},
                pinImages: this.images,
                users: {},
            }
        },
        mounted() {
            Object.values(this.images).forEach(image => {
                if (image.is_primary) {
                    this.primary = image;
                }

                if (this.adv) {
                    this.users[image.user_id] = image.username;
                }
            });

            if (this.adv) {
                this.users[31] = 'Disney Pins Blog';
                this.users[11] = 'Pin Trading DB';
            }
        },
        methods: {
            updatePrimaryImage: function(imageObj) {
                if (imageObj.deleted_at) {
                    return;
                }
                Object.values(this.images).forEach(image => {
                    image.is_primary = image.id === imageObj.id;

                    if (image.is_primary) {
                        this.primary = image;
                    }
                });
            }
        }
    }
</script>
